import { render } from "./InvoicePrintPage.vue?vue&type=template&id=f9652e2c&scoped=true"
import script from "./InvoicePrintPage.vue?vue&type=script&lang=ts"
export * from "./InvoicePrintPage.vue?vue&type=script&lang=ts"

import "./InvoicePrintPage.vue?vue&type=style&index=0&id=f9652e2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f9652e2c"

export default script